module.exports = __webpack_public_path__ + "9eb10fe4e255a79d89f8eaf0b13a0c80.png";